import OstroDynamicContent from 'app/components/OstroDynamicContent';
import useCustomization from 'app/hooks/useCustomization';

import { type NbrCtaContentProps } from './types';

const NbrContentMobile = ({ suggestedArticle }: NbrCtaContentProps) => {
  const customization = useCustomization();

  const iconUrl = customization?.open_button_action_icon;
  const iconWidth = customization?.open_button_action_icon_width || 52;
  const iconHeight = customization?.open_button_action_icon_height || 52;

  return (
    <div className="w-full h-full flex">
      <div className="flex-1 pl-[18px] pr-[6px] bg-brand-openBubbleBackground flex flex-col justify-center">
        <div className="font-bold line-clamp-1 leading-none flex items-center gap-1">
          <span className="text-brand-nextBestAction">Next</span>
          <OstroDynamicContent
            id="ostro-suggested-article-title"
            content={suggestedArticle.title}
            className="[&_p]:m-0 font-bold line-clamp-1 leading-[18px]"
          />
        </div>
        <OstroDynamicContent
          id="ostro-suggested-article-description"
          content={suggestedArticle.description}
          className="[&_p]:mb-0 min-w-fit line-clamp-2 leading-[18px]"
        />
      </div>
      <div className="w-[52px] shrink-0 bg-brand-openButtonBackground flex justify-center items-center">
        <img
          className={`w-[${iconWidth}px] h-[${iconHeight}px]`}
          src={iconUrl}
          alt=""
          aria-hidden="true"
        />
      </div>
    </div>
  );
};

export default NbrContentMobile;
